export default __webpack_public_path__ + "static/media/comment_example.5d713515.png";